import { ValueConverter } from "@skylab-shared/core";
import { EnumTranslatorBase, EnumValue, LabeledEnumValue } from "./enum-translator";

export class LabeledEnumValueConverter<TEnum extends EnumValue> implements ValueConverter<TEnum | null, LabeledEnumValue | null> {
    public constructor(
        private readonly enumTranslator: EnumTranslatorBase,
        private readonly enumType: unknown
    ) { }

    public convert(value: TEnum | null): LabeledEnumValue | null {
        if (value === null || value === undefined) {
            return null;
        }
        const typeObject = this.enumType as Record<string, unknown>;
        return Object.keys(typeObject).map(k => typeObject[k]).some(v => v === value)
            ? this.enumTranslator.getLabeledEnumValue(this.enumType as Object, value)
            : null;
    }

    public convertBack(item: LabeledEnumValue | null): TEnum | null {
        return item ? <TEnum> item.value : null;
    }
}
